import { ToolCatalog } from '@bechtel/ht-types';
import { useMemo } from 'react';

export const useToolOrderCatalogStats = (toolOrderCatalogItems: { toolCatalog: ToolCatalog; quantity: number }[]) => {
  const toolOrderCatalogStats = useMemo(() => {
    const toolTypesTotal = toolOrderCatalogItems?.reduce((acc, item) => {
      const quantity = item.quantity;
      // Follwing logic was changed by product owner. This is no longer dependent on tool type of category
      const toolTypeName = item.toolCatalog?.inventoryType === 'Consumable' ? 'Consumables' : 'Tools';
      if (toolTypeName) {
        if (!acc[toolTypeName]) {
          acc[toolTypeName] = {
            quantity,
            toolTypeName,
          };
        } else {
          acc[toolTypeName].quantity += quantity;
        }
      }
      return acc;
    }, {});

    const total: number = toolOrderCatalogItems?.reduce((acc, item) => acc + item.quantity, 0);

    return [total, toolTypesTotal];
  }, [toolOrderCatalogItems]);

  return toolOrderCatalogStats;
};
